// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var $$String = require("rescript/lib/js/string.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Selector$SmartcutsMacros = require("./Selector.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var KeyCommand$SmartcutsMacros = require("./commands/KeyCommand.bs.js");
var URLCommand$SmartcutsMacros = require("./commands/URLCommand.bs.js");
var LoopCommand$SmartcutsMacros = require("./commands/LoopCommand.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var TypeCommand$SmartcutsMacros = require("./commands/TypeCommand.bs.js");
var ClickCommand$SmartcutsMacros = require("./commands/ClickCommand.bs.js");
var RadioCommand$SmartcutsMacros = require("./commands/RadioCommand.bs.js");
var NewTabCommand$SmartcutsMacros = require("./commands/NewTabCommand.bs.js");
var PromisedValue$SmartcutsMacros = require("./PromisedValue.bs.js");
var ScrollCommand$SmartcutsMacros = require("./commands/ScrollCommand.bs.js");
var SelectCommand$SmartcutsMacros = require("./commands/SelectCommand.bs.js");
var SwitchCommand$SmartcutsMacros = require("./commands/SwitchCommand.bs.js");
var UploadCommand$SmartcutsMacros = require("./commands/UploadCommand.bs.js");
var CommandContext$SmartcutsMacros = require("./CommandContext.bs.js");
var DataDependency$SmartcutsMacros = require("./commands/shared/DataDependency.bs.js");
var CheckboxCommand$SmartcutsMacros = require("./commands/CheckboxCommand.bs.js");
var DownloadCommand$SmartcutsMacros = require("./commands/DownloadCommand.bs.js");
var FocusTabCommand$SmartcutsMacros = require("./commands/FocusTabCommand.bs.js");
var KeyComboCommand$SmartcutsMacros = require("./commands/KeyComboCommand.bs.js");
var PasswordCommand$SmartcutsMacros = require("./commands/PasswordCommand.bs.js");
var NewWindowCommand$SmartcutsMacros = require("./commands/NewWindowCommand.bs.js");
var ClickInputCommand$SmartcutsMacros = require("./commands/ClickInputCommand.bs.js");
var OpenedLinkCommand$SmartcutsMacros = require("./commands/OpenedLinkCommand.bs.js");
var SubmitFormCommand$SmartcutsMacros = require("./commands/SubmitFormCommand.bs.js");
var ContextMenuCommand$SmartcutsMacros = require("./commands/ContextMenuCommand.bs.js");
var ClickToOAuthCommand$SmartcutsMacros = require("./commands/ClickToOAuthCommand.bs.js");
var CopyImageSrcCommand$SmartcutsMacros = require("./commands/CopyImageSrcCommand.bs.js");
var GoogleSheetsCommand$SmartcutsMacros = require("./commands/GoogleSheetsCommand.bs.js");
var PasteInInputCommand$SmartcutsMacros = require("./commands/PasteInInputCommand.bs.js");
var NewTabWithUrlCommand$SmartcutsMacros = require("./commands/NewTabWithUrlCommand.bs.js");
var ClientRedirectCommand$SmartcutsMacros = require("./commands/ClientRedirectCommand.bs.js");
var ServerRedirectCommand$SmartcutsMacros = require("./commands/ServerRedirectCommand.bs.js");
var CopyLinkAddressCommand$SmartcutsMacros = require("./commands/CopyLinkAddressCommand.bs.js");
var MoveInputCursorCommand$SmartcutsMacros = require("./commands/MoveInputCursorCommand.bs.js");
var Selection__InputCursor$SmartcutsMacros = require("./Selection/Selection__InputCursor.bs.js");
var NewWindowWithUrlCommand$SmartcutsMacros = require("./commands/NewWindowWithUrlCommand.bs.js");
var SelectionRelatedCommands$SmartcutsMacros = require("./commands/shared/SelectionRelatedCommands.bs.js");
var WithElementGroupsCommand$SmartcutsMacros = require("./commands/WithElementGroupsCommand.bs.js");
var SubmitFormRedirectCommand$SmartcutsMacros = require("./commands/SubmitFormRedirectCommand.bs.js");
var ClickContentEditableCommand$SmartcutsMacros = require("./commands/ClickContentEditableCommand.bs.js");
var ScreenshotToClipboardCommand$SmartcutsMacros = require("./commands/ScreenshotToClipboardCommand.bs.js");
var PasteInContentEditableCommand$SmartcutsMacros = require("./commands/PasteInContentEditableCommand.bs.js");
var GenericCommandWithContextGlobal$SmartcutsMacros = require("./GenericCommandWithContextGlobal.bs.js");
var MoveContentEditableCursorCommand$SmartcutsMacros = require("./commands/MoveContentEditableCursorCommand.bs.js");
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = require("./InterfaceBtwnRecordingAndPlayback.bs.js");
var PasteImageInContentEditableCommand$SmartcutsMacros = require("./commands/PasteImageInContentEditableCommand.bs.js");
var DomElementIdentifierPaired__WithSelector$SmartcutsMacros = require("./DomElementIdentifierPaired__WithSelector.bs.js");

var schemaVersion = "19.0.0";

function t_encode(encoder_domElementRepresentation, encoder_clickCommandValue, encoder_typeCommandValue, encoder_focusTabCommandValue, encoder_checkboxCommandValue, encoder_selectCommandValue, encoder_selectionRelatedCommandValue, encoder_copyLinkAddressCommandValue, encoder_pasteInInputCommandValue, encoder_pasteInContentEditableCommandValue, encoder_moveInputCursorCommandValue, encoder_clickInputCommandValue, encoder_moveContentEditableCommandValue, encoder_clickContentEditableCommandValue, encoder_radioCommandValue, encoder_downloadCommandValue, encoder_googleSheetsCommandValue, encoder_contextMenuCommandValue, encoder_screenshotToClipboardCommandValue, encoder_pasteImageInContentEditableCommandValue, encoder_passwordCommandValue, encoder_clickToOAuthCommandValue, encoder_uploadCommandValue, encoder_copyImageSrcCommandValue, encoder_withElementGroupsCommandValue, v) {
  if (typeof v === "number") {
    switch (v) {
      case /* ReloadCommand */0 :
          return ["ReloadCommand"];
      case /* ForwardCommand */1 :
          return ["ForwardCommand"];
      case /* BackCommand */2 :
          return ["BackCommand"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* NewWindowCommand */0 :
          return [
                  "NewWindowCommand",
                  NewWindowCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* NewWindowWithUrlCommand */1 :
          return [
                  "NewWindowWithUrlCommand",
                  NewWindowWithUrlCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* NewTabCommand */2 :
          return [
                  "NewTabCommand",
                  NewTabCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* NewTabWithUrlCommand */3 :
          return [
                  "NewTabWithUrlCommand",
                  NewTabWithUrlCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* CloseTabCommand */4 :
          return [
                  "CloseTabCommand",
                  InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode(v._0)
                ];
      case /* FocusTabCommand */5 :
          return [
                  "FocusTabCommand",
                  Curry._1(encoder_focusTabCommandValue, v._0)
                ];
      case /* URLCommand */6 :
          return [
                  "URLCommand",
                  URLCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* OpenedLinkCommand */7 :
          return [
                  "OpenedLinkCommand",
                  OpenedLinkCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* SubmitFormCommand */8 :
          return [
                  "SubmitFormCommand",
                  SubmitFormCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* SubmitFormRedirectCommand */9 :
          return [
                  "SubmitFormRedirectCommand",
                  SubmitFormRedirectCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* ClientRedirectCommand */10 :
          return [
                  "ClientRedirectCommand",
                  ClientRedirectCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* ServerRedirectCommand */11 :
          return [
                  "ServerRedirectCommand",
                  ServerRedirectCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* ClickCommand */12 :
          return [
                  "ClickCommand",
                  Curry._1(encoder_clickCommandValue, v._0)
                ];
      case /* ClickInputCommand */13 :
          return [
                  "ClickInputCommand",
                  Curry._1(encoder_clickInputCommandValue, v._0)
                ];
      case /* ClickContentEditableCommand */14 :
          return [
                  "ClickContentEditableCommand",
                  Curry._1(encoder_clickContentEditableCommandValue, v._0)
                ];
      case /* TypeCommand */15 :
          return [
                  "TypeCommand",
                  Curry._1(encoder_typeCommandValue, v._0)
                ];
      case /* CheckboxCommand */16 :
          return [
                  "CheckboxCommand",
                  Curry._1(encoder_checkboxCommandValue, v._0)
                ];
      case /* SelectCommand */17 :
          return [
                  "SelectCommand",
                  Curry._1(encoder_selectCommandValue, v._0)
                ];
      case /* RadioCommand */18 :
          return [
                  "RadioCommand",
                  Curry._1(encoder_radioCommandValue, v._0)
                ];
      case /* KeyCommand */19 :
          return [
                  "KeyCommand",
                  KeyCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* KeyComboCommand */20 :
          return [
                  "KeyComboCommand",
                  KeyComboCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* SelectionCommand */21 :
          return [
                  "SelectionCommand",
                  Curry._1(encoder_selectionRelatedCommandValue, v._0)
                ];
      case /* MoveInputCursorCommand */22 :
          return [
                  "MoveInputCursorCommand",
                  Curry._1(encoder_moveInputCursorCommandValue, v._0)
                ];
      case /* MoveContentEditableCursorCommand */23 :
          return [
                  "MoveContentEditableCursorCommand",
                  Curry._1(encoder_moveContentEditableCommandValue, v._0)
                ];
      case /* CopyCommand */24 :
          return [
                  "CopyCommand",
                  Curry._1(encoder_selectionRelatedCommandValue, v._0)
                ];
      case /* CopyLinkAddressCommand */25 :
          return [
                  "CopyLinkAddressCommand",
                  Curry._1(encoder_copyLinkAddressCommandValue, v._0)
                ];
      case /* CutCommand */26 :
          return [
                  "CutCommand",
                  Curry._1(encoder_selectionRelatedCommandValue, v._0)
                ];
      case /* PasteInInputCommand */27 :
          return [
                  "PasteInInputCommand",
                  Curry._1(encoder_pasteInInputCommandValue, v._0)
                ];
      case /* PasteInContentEditableCommand */28 :
          return [
                  "PasteInContentEditableCommand",
                  Curry._1(encoder_pasteInContentEditableCommandValue, v._0)
                ];
      case /* DragCommand */29 :
          return [
                  "DragCommand",
                  Curry._1(encoder_domElementRepresentation, v._0)
                ];
      case /* DropCommand */30 :
          return [
                  "DropCommand",
                  Curry._1(encoder_domElementRepresentation, v._0)
                ];
      case /* ScrollCommand */31 :
          return [
                  "ScrollCommand",
                  ScrollCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* DownloadCommand */32 :
          return [
                  "DownloadCommand",
                  Curry._1(encoder_downloadCommandValue, v._0)
                ];
      case /* GoogleSheetsCommand */33 :
          return [
                  "GoogleSheetsCommand",
                  Curry._1(encoder_googleSheetsCommandValue, v._0)
                ];
      case /* ContextMenuCommand */34 :
          return [
                  "ContextMenuCommand",
                  Curry._1(encoder_contextMenuCommandValue, v._0)
                ];
      case /* LoopCommand */35 :
          return [
                  "LoopCommand",
                  LoopCommand$SmartcutsMacros.CommandValue.t_encode(v._0)
                ];
      case /* SwitchCommand */36 :
          return [
                  "SwitchCommand",
                  SwitchCommand$SmartcutsMacros.CommandValue.t_encode((function (param) {
                          return t_encode(encoder_domElementRepresentation, encoder_clickCommandValue, encoder_typeCommandValue, encoder_focusTabCommandValue, encoder_checkboxCommandValue, encoder_selectCommandValue, encoder_selectionRelatedCommandValue, encoder_copyLinkAddressCommandValue, encoder_pasteInInputCommandValue, encoder_pasteInContentEditableCommandValue, encoder_moveInputCursorCommandValue, encoder_clickInputCommandValue, encoder_moveContentEditableCommandValue, encoder_clickContentEditableCommandValue, encoder_radioCommandValue, encoder_downloadCommandValue, encoder_googleSheetsCommandValue, encoder_contextMenuCommandValue, encoder_screenshotToClipboardCommandValue, encoder_pasteImageInContentEditableCommandValue, encoder_passwordCommandValue, encoder_clickToOAuthCommandValue, encoder_uploadCommandValue, encoder_copyImageSrcCommandValue, encoder_withElementGroupsCommandValue, param);
                        }), v._0)
                ];
      case /* ScreenshotToClipboardCommand */37 :
          return [
                  "ScreenshotToClipboardCommand",
                  Curry._1(encoder_screenshotToClipboardCommandValue, v._0)
                ];
      case /* PasteImageInContentEditableCommand */38 :
          return [
                  "PasteImageInContentEditableCommand",
                  Curry._1(encoder_pasteImageInContentEditableCommandValue, v._0)
                ];
      case /* PasswordCommand */39 :
          return [
                  "PasswordCommand",
                  Curry._1(encoder_passwordCommandValue, v._0)
                ];
      case /* ClickToOAuthCommand */40 :
          return [
                  "ClickToOAuthCommand",
                  Curry._1(encoder_clickToOAuthCommandValue, v._0)
                ];
      case /* UploadCommand */41 :
          return [
                  "UploadCommand",
                  Curry._1(encoder_uploadCommandValue, v._0)
                ];
      case /* CopyImageSrcCommand */42 :
          return [
                  "CopyImageSrcCommand",
                  Curry._1(encoder_copyImageSrcCommandValue, v._0)
                ];
      case /* WithElementGroupsCommand */43 :
          return [
                  "WithElementGroupsCommand",
                  Curry._1(encoder_withElementGroupsCommandValue, v._0)
                ];
      
    }
  }
}

function t_decode(decoder_domElementRepresentation, decoder_clickCommandValue, decoder_typeCommandValue, decoder_focusTabCommandValue, decoder_checkboxCommandValue, decoder_selectCommandValue, decoder_selectionRelatedCommandValue, decoder_copyLinkAddressCommandValue, decoder_pasteInInputCommandValue, decoder_pasteInContentEditableCommandValue, decoder_moveInputCursorCommandValue, decoder_clickInputCommandValue, decoder_moveContentEditableCommandValue, decoder_clickContentEditableCommandValue, decoder_radioCommandValue, decoder_downloadCommandValue, decoder_googleSheetsCommandValue, decoder_contextMenuCommandValue, decoder_screenshotToClipboardCommandValue, decoder_pasteImageInContentEditableCommandValue, decoder_passwordCommandValue, decoder_clickToOAuthCommandValue, decoder_uploadCommandValue, decoder_copyImageSrcCommandValue, decoder_withElementGroupsCommandValue, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BackCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* BackCommand */2
                  };
          }
      case "CheckboxCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(decoder_checkboxCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CheckboxCommand */16,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "ClickCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._1(decoder_clickCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ClickCommand */12,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "ClickContentEditableCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Curry._1(decoder_clickContentEditableCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ClickContentEditableCommand */14,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "ClickInputCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Curry._1(decoder_clickInputCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ClickInputCommand */13,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "ClickToOAuthCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Curry._1(decoder_clickToOAuthCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ClickToOAuthCommand */40,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "ClientRedirectCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = ClientRedirectCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ClientRedirectCommand */10,
                      _0: v0$5._0
                    }
                  };
          }
          var e$5 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "CloseTabCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CloseTabCommand */4,
                      _0: v0$6._0
                    }
                  };
          }
          var e$6 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "ContextMenuCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = Curry._1(decoder_contextMenuCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ContextMenuCommand */34,
                      _0: v0$7._0
                    }
                  };
          }
          var e$7 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "CopyCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$8 = Curry._1(decoder_selectionRelatedCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$8.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CopyCommand */24,
                      _0: v0$8._0
                    }
                  };
          }
          var e$8 = v0$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "CopyImageSrcCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$9 = Curry._1(decoder_copyImageSrcCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$9.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CopyImageSrcCommand */42,
                      _0: v0$9._0
                    }
                  };
          }
          var e$9 = v0$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "CopyLinkAddressCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$10 = Curry._1(decoder_copyLinkAddressCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$10.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CopyLinkAddressCommand */25,
                      _0: v0$10._0
                    }
                  };
          }
          var e$10 = v0$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      case "CutCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$11 = Curry._1(decoder_selectionRelatedCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$11.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* CutCommand */26,
                      _0: v0$11._0
                    }
                  };
          }
          var e$11 = v0$11._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
      case "DownloadCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$12 = Curry._1(decoder_downloadCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$12.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DownloadCommand */32,
                      _0: v0$12._0
                    }
                  };
          }
          var e$12 = v0$12._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
      case "DragCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$13 = Curry._1(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$13.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DragCommand */29,
                      _0: v0$13._0
                    }
                  };
          }
          var e$13 = v0$13._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                  }
                };
      case "DropCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$14 = Curry._1(decoder_domElementRepresentation, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$14.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DropCommand */30,
                      _0: v0$14._0
                    }
                  };
          }
          var e$14 = v0$14._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$14.path,
                    message: e$14.message,
                    value: e$14.value
                  }
                };
      case "FocusTabCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$15 = Curry._1(decoder_focusTabCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$15.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* FocusTabCommand */5,
                      _0: v0$15._0
                    }
                  };
          }
          var e$15 = v0$15._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$15.path,
                    message: e$15.message,
                    value: e$15.value
                  }
                };
      case "ForwardCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ForwardCommand */1
                  };
          }
      case "GoogleSheetsCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$16 = Curry._1(decoder_googleSheetsCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$16.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* GoogleSheetsCommand */33,
                      _0: v0$16._0
                    }
                  };
          }
          var e$16 = v0$16._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$16.path,
                    message: e$16.message,
                    value: e$16.value
                  }
                };
      case "KeyComboCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$17 = KeyComboCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$17.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* KeyComboCommand */20,
                      _0: v0$17._0
                    }
                  };
          }
          var e$17 = v0$17._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$17.path,
                    message: e$17.message,
                    value: e$17.value
                  }
                };
      case "KeyCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$18 = KeyCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$18.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* KeyCommand */19,
                      _0: v0$18._0
                    }
                  };
          }
          var e$18 = v0$18._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$18.path,
                    message: e$18.message,
                    value: e$18.value
                  }
                };
      case "LoopCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$19 = LoopCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$19.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* LoopCommand */35,
                      _0: v0$19._0
                    }
                  };
          }
          var e$19 = v0$19._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$19.path,
                    message: e$19.message,
                    value: e$19.value
                  }
                };
      case "MoveContentEditableCursorCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$20 = Curry._1(decoder_moveContentEditableCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$20.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* MoveContentEditableCursorCommand */23,
                      _0: v0$20._0
                    }
                  };
          }
          var e$20 = v0$20._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$20.path,
                    message: e$20.message,
                    value: e$20.value
                  }
                };
      case "MoveInputCursorCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$21 = Curry._1(decoder_moveInputCursorCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$21.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* MoveInputCursorCommand */22,
                      _0: v0$21._0
                    }
                  };
          }
          var e$21 = v0$21._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$21.path,
                    message: e$21.message,
                    value: e$21.value
                  }
                };
      case "NewTabCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$22 = NewTabCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$22.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NewTabCommand */2,
                      _0: v0$22._0
                    }
                  };
          }
          var e$22 = v0$22._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$22.path,
                    message: e$22.message,
                    value: e$22.value
                  }
                };
      case "NewTabWithUrlCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$23 = NewTabWithUrlCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$23.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NewTabWithUrlCommand */3,
                      _0: v0$23._0
                    }
                  };
          }
          var e$23 = v0$23._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$23.path,
                    message: e$23.message,
                    value: e$23.value
                  }
                };
      case "NewWindowCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$24 = NewWindowCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$24.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NewWindowCommand */0,
                      _0: v0$24._0
                    }
                  };
          }
          var e$24 = v0$24._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$24.path,
                    message: e$24.message,
                    value: e$24.value
                  }
                };
      case "NewWindowWithUrlCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$25 = NewWindowWithUrlCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$25.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* NewWindowWithUrlCommand */1,
                      _0: v0$25._0
                    }
                  };
          }
          var e$25 = v0$25._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$25.path,
                    message: e$25.message,
                    value: e$25.value
                  }
                };
      case "OpenedLinkCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$26 = OpenedLinkCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$26.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* OpenedLinkCommand */7,
                      _0: v0$26._0
                    }
                  };
          }
          var e$26 = v0$26._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$26.path,
                    message: e$26.message,
                    value: e$26.value
                  }
                };
      case "PasswordCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$27 = Curry._1(decoder_passwordCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$27.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PasswordCommand */39,
                      _0: v0$27._0
                    }
                  };
          }
          var e$27 = v0$27._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$27.path,
                    message: e$27.message,
                    value: e$27.value
                  }
                };
      case "PasteImageInContentEditableCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$28 = Curry._1(decoder_pasteImageInContentEditableCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$28.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PasteImageInContentEditableCommand */38,
                      _0: v0$28._0
                    }
                  };
          }
          var e$28 = v0$28._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$28.path,
                    message: e$28.message,
                    value: e$28.value
                  }
                };
      case "PasteInContentEditableCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$29 = Curry._1(decoder_pasteInContentEditableCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$29.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PasteInContentEditableCommand */28,
                      _0: v0$29._0
                    }
                  };
          }
          var e$29 = v0$29._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$29.path,
                    message: e$29.message,
                    value: e$29.value
                  }
                };
      case "PasteInInputCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$30 = Curry._1(decoder_pasteInInputCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$30.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PasteInInputCommand */27,
                      _0: v0$30._0
                    }
                  };
          }
          var e$30 = v0$30._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$30.path,
                    message: e$30.message,
                    value: e$30.value
                  }
                };
      case "RadioCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$31 = Curry._1(decoder_radioCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$31.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* RadioCommand */18,
                      _0: v0$31._0
                    }
                  };
          }
          var e$31 = v0$31._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$31.path,
                    message: e$31.message,
                    value: e$31.value
                  }
                };
      case "ReloadCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ReloadCommand */0
                  };
          }
      case "ScreenshotToClipboardCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$32 = Curry._1(decoder_screenshotToClipboardCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$32.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ScreenshotToClipboardCommand */37,
                      _0: v0$32._0
                    }
                  };
          }
          var e$32 = v0$32._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$32.path,
                    message: e$32.message,
                    value: e$32.value
                  }
                };
      case "ScrollCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$33 = ScrollCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$33.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ScrollCommand */31,
                      _0: v0$33._0
                    }
                  };
          }
          var e$33 = v0$33._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$33.path,
                    message: e$33.message,
                    value: e$33.value
                  }
                };
      case "SelectCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$34 = Curry._1(decoder_selectCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$34.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectCommand */17,
                      _0: v0$34._0
                    }
                  };
          }
          var e$34 = v0$34._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$34.path,
                    message: e$34.message,
                    value: e$34.value
                  }
                };
      case "SelectionCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$35 = Curry._1(decoder_selectionRelatedCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$35.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectionCommand */21,
                      _0: v0$35._0
                    }
                  };
          }
          var e$35 = v0$35._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$35.path,
                    message: e$35.message,
                    value: e$35.value
                  }
                };
      case "ServerRedirectCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$36 = ServerRedirectCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$36.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ServerRedirectCommand */11,
                      _0: v0$36._0
                    }
                  };
          }
          var e$36 = v0$36._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$36.path,
                    message: e$36.message,
                    value: e$36.value
                  }
                };
      case "SubmitFormCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$37 = SubmitFormCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$37.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SubmitFormCommand */8,
                      _0: v0$37._0
                    }
                  };
          }
          var e$37 = v0$37._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$37.path,
                    message: e$37.message,
                    value: e$37.value
                  }
                };
      case "SubmitFormRedirectCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$38 = SubmitFormRedirectCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$38.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SubmitFormRedirectCommand */9,
                      _0: v0$38._0
                    }
                  };
          }
          var e$38 = v0$38._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$38.path,
                    message: e$38.message,
                    value: e$38.value
                  }
                };
      case "SwitchCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$39 = SwitchCommand$SmartcutsMacros.CommandValue.t_decode((function (param) {
                  return t_decode(decoder_domElementRepresentation, decoder_clickCommandValue, decoder_typeCommandValue, decoder_focusTabCommandValue, decoder_checkboxCommandValue, decoder_selectCommandValue, decoder_selectionRelatedCommandValue, decoder_copyLinkAddressCommandValue, decoder_pasteInInputCommandValue, decoder_pasteInContentEditableCommandValue, decoder_moveInputCursorCommandValue, decoder_clickInputCommandValue, decoder_moveContentEditableCommandValue, decoder_clickContentEditableCommandValue, decoder_radioCommandValue, decoder_downloadCommandValue, decoder_googleSheetsCommandValue, decoder_contextMenuCommandValue, decoder_screenshotToClipboardCommandValue, decoder_pasteImageInContentEditableCommandValue, decoder_passwordCommandValue, decoder_clickToOAuthCommandValue, decoder_uploadCommandValue, decoder_copyImageSrcCommandValue, decoder_withElementGroupsCommandValue, param);
                }), Belt_Array.getExn(jsonArr$1, 1));
          if (v0$39.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SwitchCommand */36,
                      _0: v0$39._0
                    }
                  };
          }
          var e$39 = v0$39._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$39.path,
                    message: e$39.message,
                    value: e$39.value
                  }
                };
      case "TypeCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$40 = Curry._1(decoder_typeCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$40.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TypeCommand */15,
                      _0: v0$40._0
                    }
                  };
          }
          var e$40 = v0$40._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$40.path,
                    message: e$40.message,
                    value: e$40.value
                  }
                };
      case "URLCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$41 = URLCommand$SmartcutsMacros.CommandValue.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$41.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* URLCommand */6,
                      _0: v0$41._0
                    }
                  };
          }
          var e$41 = v0$41._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$41.path,
                    message: e$41.message,
                    value: e$41.value
                  }
                };
      case "UploadCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$42 = Curry._1(decoder_uploadCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$42.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UploadCommand */41,
                      _0: v0$42._0
                    }
                  };
          }
          var e$42 = v0$42._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$42.path,
                    message: e$42.message,
                    value: e$42.value
                  }
                };
      case "WithElementGroupsCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$43 = Curry._1(decoder_withElementGroupsCommandValue, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$43.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* WithElementGroupsCommand */43,
                      _0: v0$43._0
                    }
                  };
          }
          var e$43 = v0$43._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$43.path,
                    message: e$43.message,
                    value: e$43.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function recordingCommand_encode(v) {
  return t_encode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_encode, ClickCommand$SmartcutsMacros.CommandValue.Recording.t_encode, TypeCommand$SmartcutsMacros.CommandValue.Recording.t_encode, (function (param) {
                return PromisedValue$SmartcutsMacros.t_encode(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_encode, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_encode, param);
              }), CheckboxCommand$SmartcutsMacros.CommandValue.Recording.t_encode, SelectCommand$SmartcutsMacros.CommandValue.Recording.t_encode, SelectionRelatedCommands$SmartcutsMacros.CommandValue.Recording.t_encode, CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Recording.t_encode, PasteInInputCommand$SmartcutsMacros.CommandValue.Recording.t_encode, PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Recording.t_encode, MoveInputCursorCommand$SmartcutsMacros.CommandValue.Recording.t_encode, ClickInputCommand$SmartcutsMacros.CommandValue.Recording.t_encode, MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Recording.t_encode, ClickContentEditableCommand$SmartcutsMacros.CommandValue.Recording.t_encode, RadioCommand$SmartcutsMacros.CommandValue.Recording.t_encode, DownloadCommand$SmartcutsMacros.CommandValue.Recording.t_encode, GoogleSheetsCommand$SmartcutsMacros.CommandValue.Recording.t_encode, ContextMenuCommand$SmartcutsMacros.CommandValue.Recording.t_encode, ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Recording.t_encode, PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Recording.t_encode, PasswordCommand$SmartcutsMacros.CommandValue.Recording.t_encode, ClickToOAuthCommand$SmartcutsMacros.CommandValue.Recording.t_encode, UploadCommand$SmartcutsMacros.CommandValue.Recording.t_encode, CopyImageSrcCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.t_encode, WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.t_encode, v);
}

function recordingCommand_decode(v) {
  return t_decode(DomElementIdentifierPaired__WithSelector$SmartcutsMacros.t_decode, ClickCommand$SmartcutsMacros.CommandValue.Recording.t_decode, TypeCommand$SmartcutsMacros.CommandValue.Recording.t_decode, (function (param) {
                return PromisedValue$SmartcutsMacros.t_decode(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.t_decode, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.t_decode, param);
              }), CheckboxCommand$SmartcutsMacros.CommandValue.Recording.t_decode, SelectCommand$SmartcutsMacros.CommandValue.Recording.t_decode, SelectionRelatedCommands$SmartcutsMacros.CommandValue.Recording.t_decode, CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Recording.t_decode, PasteInInputCommand$SmartcutsMacros.CommandValue.Recording.t_decode, PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Recording.t_decode, MoveInputCursorCommand$SmartcutsMacros.CommandValue.Recording.t_decode, ClickInputCommand$SmartcutsMacros.CommandValue.Recording.t_decode, MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Recording.t_decode, ClickContentEditableCommand$SmartcutsMacros.CommandValue.Recording.t_decode, RadioCommand$SmartcutsMacros.CommandValue.Recording.t_decode, DownloadCommand$SmartcutsMacros.CommandValue.Recording.t_decode, GoogleSheetsCommand$SmartcutsMacros.CommandValue.Recording.t_decode, ContextMenuCommand$SmartcutsMacros.CommandValue.Recording.t_decode, ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Recording.t_decode, PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Recording.t_decode, PasswordCommand$SmartcutsMacros.CommandValue.Recording.t_decode, ClickToOAuthCommand$SmartcutsMacros.CommandValue.Recording.t_decode, UploadCommand$SmartcutsMacros.CommandValue.Recording.t_decode, CopyImageSrcCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.t_decode, WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.t_decode, v);
}

function factorOutDynamicVars(cmd) {
  if (typeof cmd === "number") {
    return {
            vars: [],
            factoredValue: cmd
          };
  }
  if (cmd.TAG !== /* TypeCommand */15) {
    return {
            vars: [],
            factoredValue: cmd
          };
  }
  var match = Curry._1(TypeCommand$SmartcutsMacros.CommandValue.Recording.Pack.factorOutDynamicVars, cmd._0);
  return {
          vars: match.vars,
          factoredValue: {
            TAG: /* TypeCommand */15,
            _0: match.factoredValue
          }
        };
}

function substituteInDynamicVars(param) {
  var factoredValue = param.factoredValue;
  var vars = param.vars;
  if (typeof factoredValue === "number") {
    return factoredValue;
  }
  if (factoredValue.TAG !== /* TypeCommand */15) {
    return factoredValue;
  }
  var match = factoredValue._0;
  var match$1 = match.labeledTextInputValueDiff;
  var match$2 = match.domElementIdentifierWithSelector;
  var arg = Js_json.decodeArray(Caml_array.get(vars, 0));
  var varsForValueDiff = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expected array of vars");
  var arg$1 = Js_json.decodeArray(Caml_array.get(vars, 1));
  var varsForSelector = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
      })("Expected array of vars");
  var tmp;
  if (match$1.valueDiff.TAG === /* AddText */0) {
    var arg$2 = Js_json.decodeString(Caml_array.get(varsForValueDiff, 0));
    var addText = (function (param) {
          return OptionUtils$SmartcutsMacros.getExn(param, arg$2);
        })("Expected var to be a string");
    tmp = {
      TAG: /* AddText */0,
      _0: addText
    };
  } else {
    var deleteText = Caml_array.get(varsForValueDiff, 0);
    tmp = {
      TAG: /* DeleteText */1,
      _0: deleteText
    };
  }
  return {
          TAG: /* TypeCommand */15,
          _0: {
            domElementIdentifierWithSelector: {
              domElementIdentifier: match$2.domElementIdentifier,
              selector: Selector$SmartcutsMacros.Pack.substituteInDynamicVars({
                    vars: varsForSelector,
                    factoredValue: match$2.selector
                  })
            },
            labeledTextInputValueDiff: {
              label: match$1.label,
              valueDiff: tmp
            }
          }
        };
}

var Pack = {
  factorOutDynamicVars: factorOutDynamicVars,
  substituteInDynamicVars: substituteInDynamicVars
};

var ForRecording = {
  Pack: Pack
};

function authoringCommand_encode(v) {
  return t_encode(Selector$SmartcutsMacros.selector_encode, ClickCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, TypeCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, FocusTabCommand$SmartcutsMacros.CommandValue.t_encode, CheckboxCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, SelectCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, SelectionRelatedCommands$SmartcutsMacros.CommandValue.Authoring.t_encode, CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, PasteInInputCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, MoveInputCursorCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, ClickInputCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, ClickContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, RadioCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, DownloadCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, GoogleSheetsCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, ContextMenuCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, PasswordCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, ClickToOAuthCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, UploadCommand$SmartcutsMacros.CommandValue.Authoring.t_encode, CopyImageSrcCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.t_encode, WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.t_encode, v);
}

function authoringCommand_decode(v) {
  return t_decode(Selector$SmartcutsMacros.selector_decode, ClickCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, TypeCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, FocusTabCommand$SmartcutsMacros.CommandValue.t_decode, CheckboxCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, SelectCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, SelectionRelatedCommands$SmartcutsMacros.CommandValue.Authoring.t_decode, CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, PasteInInputCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, MoveInputCursorCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, ClickInputCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, ClickContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, RadioCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, DownloadCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, GoogleSheetsCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, ContextMenuCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, PasswordCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, ClickToOAuthCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, UploadCommand$SmartcutsMacros.CommandValue.Authoring.t_decode, CopyImageSrcCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.t_decode, WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.t_decode, v);
}

function factorOutDynamicVars$1(cmd) {
  if (typeof cmd === "number") {
    return {
            vars: [],
            factoredValue: cmd
          };
  }
  if (cmd.TAG !== /* TypeCommand */15) {
    return {
            vars: [],
            factoredValue: cmd
          };
  }
  var match = Curry._1(TypeCommand$SmartcutsMacros.CommandValue.Authoring.Pack.factorOutDynamicVars, cmd._0);
  return {
          vars: match.vars,
          factoredValue: {
            TAG: /* TypeCommand */15,
            _0: match.factoredValue
          }
        };
}

function substituteInDynamicVars$1(param) {
  var factoredValue = param.factoredValue;
  var vars = param.vars;
  if (typeof factoredValue === "number") {
    return factoredValue;
  }
  if (factoredValue.TAG !== /* TypeCommand */15) {
    return factoredValue;
  }
  var match = factoredValue._0;
  var match$1 = match.labeledTextInputValueDiff;
  var valueDiff = match$1.valueDiff;
  var arg = Js_json.decodeArray(Caml_array.get(vars, 0));
  var varsForValueDiff = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg);
      })("Expected array of vars");
  var arg$1 = Js_json.decodeArray(Caml_array.get(vars, 1));
  var varsForSelector = (function (param) {
        return OptionUtils$SmartcutsMacros.getExn(param, arg$1);
      })("Expected array of vars");
  var tmp;
  if (valueDiff.TAG === /* AddText */0) {
    tmp = {
      TAG: /* AddText */0,
      _0: Curry._1(DataDependency$SmartcutsMacros.DataRef.Pack.substituteInDynamicVars, {
            vars: vars,
            factoredValue: valueDiff._0
          })
    };
  } else {
    var deleteText = Caml_array.get(varsForValueDiff, 0);
    tmp = {
      TAG: /* DeleteText */1,
      _0: {
        recording: deleteText,
        semantics: valueDiff._0.semantics
      }
    };
  }
  return {
          TAG: /* TypeCommand */15,
          _0: {
            selector: Selector$SmartcutsMacros.Pack.substituteInDynamicVars({
                  vars: varsForSelector,
                  factoredValue: match.selector
                }),
            labeledTextInputValueDiff: {
              label: match$1.label,
              valueDiff: tmp
            }
          }
        };
}

var Pack$1 = {
  factorOutDynamicVars: factorOutDynamicVars$1,
  substituteInDynamicVars: substituteInDynamicVars$1
};

var ForAuthoring = {
  Pack: Pack$1
};

function playbackCommand_encode(v) {
  return t_encode(Selector$SmartcutsMacros.selector_encode, ClickCommand$SmartcutsMacros.CommandValue.Playback.t_encode, TypeCommand$SmartcutsMacros.CommandValue.Playback.t_encode, FocusTabCommand$SmartcutsMacros.CommandValue.t_encode, CheckboxCommand$SmartcutsMacros.CommandValue.Playback.t_encode, SelectCommand$SmartcutsMacros.CommandValue.Playback.t_encode, SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.t_encode, CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Playback.t_encode, PasteInInputCommand$SmartcutsMacros.CommandValue.Playback.t_encode, PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_encode, MoveInputCursorCommand$SmartcutsMacros.CommandValue.Playback.t_encode, ClickInputCommand$SmartcutsMacros.CommandValue.Playback.t_encode, MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Playback.t_encode, ClickContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_encode, RadioCommand$SmartcutsMacros.CommandValue.Playback.t_encode, DownloadCommand$SmartcutsMacros.CommandValue.Playback.t_encode, GoogleSheetsCommand$SmartcutsMacros.CommandValue.Playback.t_encode, ContextMenuCommand$SmartcutsMacros.CommandValue.Playback.t_encode, ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Playback.t_encode, PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_encode, PasswordCommand$SmartcutsMacros.CommandValue.Playback.t_encode, ClickToOAuthCommand$SmartcutsMacros.CommandValue.Playback.t_encode, UploadCommand$SmartcutsMacros.CommandValue.Playback.t_encode, CopyImageSrcCommand$SmartcutsMacros.CommandValue.Playback.t_encode, WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.t_encode, v);
}

function playbackCommand_decode(v) {
  return t_decode(Selector$SmartcutsMacros.selector_decode, ClickCommand$SmartcutsMacros.CommandValue.Playback.t_decode, TypeCommand$SmartcutsMacros.CommandValue.Playback.t_decode, FocusTabCommand$SmartcutsMacros.CommandValue.t_decode, CheckboxCommand$SmartcutsMacros.CommandValue.Playback.t_decode, SelectCommand$SmartcutsMacros.CommandValue.Playback.t_decode, SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.t_decode, CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Playback.t_decode, PasteInInputCommand$SmartcutsMacros.CommandValue.Playback.t_decode, PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_decode, MoveInputCursorCommand$SmartcutsMacros.CommandValue.Playback.t_decode, ClickInputCommand$SmartcutsMacros.CommandValue.Playback.t_decode, MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Playback.t_decode, ClickContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_decode, RadioCommand$SmartcutsMacros.CommandValue.Playback.t_decode, DownloadCommand$SmartcutsMacros.CommandValue.Playback.t_decode, GoogleSheetsCommand$SmartcutsMacros.CommandValue.Playback.t_decode, ContextMenuCommand$SmartcutsMacros.CommandValue.Playback.t_decode, ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Playback.t_decode, PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.t_decode, PasswordCommand$SmartcutsMacros.CommandValue.Playback.t_decode, ClickToOAuthCommand$SmartcutsMacros.CommandValue.Playback.t_decode, UploadCommand$SmartcutsMacros.CommandValue.Playback.t_decode, CopyImageSrcCommand$SmartcutsMacros.CommandValue.Playback.t_decode, WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.t_decode, v);
}

function factorOutDynamicVars$2(cmd) {
  if (typeof cmd === "number") {
    return {
            vars: [],
            factoredValue: cmd
          };
  }
  if (cmd.TAG !== /* TypeCommand */15) {
    return {
            vars: [],
            factoredValue: cmd
          };
  }
  var match = Curry._1(TypeCommand$SmartcutsMacros.CommandValue.Playback.Pack.factorOutDynamicVars, cmd._0);
  return {
          vars: match.vars,
          factoredValue: {
            TAG: /* TypeCommand */15,
            _0: match.factoredValue
          }
        };
}

function substituteInDynamicVars$2(param) {
  var factoredValue = param.factoredValue;
  if (typeof factoredValue === "number" || factoredValue.TAG !== /* TypeCommand */15) {
    return factoredValue;
  } else {
    return {
            TAG: /* TypeCommand */15,
            _0: Curry._1(TypeCommand$SmartcutsMacros.CommandValue.Playback.Pack.substituteInDynamicVars, {
                  vars: param.vars,
                  factoredValue: factoredValue._0
                })
          };
  }
}

var Pack$2 = {
  factorOutDynamicVars: factorOutDynamicVars$2,
  substituteInDynamicVars: substituteInDynamicVars$2
};

function isDownloadCommand(command) {
  if (typeof command === "number" || command.TAG !== /* DownloadCommand */32) {
    return false;
  } else {
    return true;
  }
}

function isOpenedLinkCommand(command) {
  if (typeof command === "number" || command.TAG !== /* OpenedLinkCommand */7) {
    return false;
  } else {
    return true;
  }
}

function isLoopCommand(command) {
  if (typeof command === "number" || command.TAG !== /* LoopCommand */35) {
    return false;
  } else {
    return true;
  }
}

function selectorGet(command) {
  if (typeof command === "number") {
    return [];
  }
  switch (command.TAG | 0) {
    case /* ClickCommand */12 :
        return Curry._1(ClickCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* ClickInputCommand */13 :
        return Curry._1(ClickInputCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* ClickContentEditableCommand */14 :
        return Curry._1(ClickContentEditableCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* TypeCommand */15 :
        return Curry._1(TypeCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* CheckboxCommand */16 :
        return Curry._1(CheckboxCommand$SmartcutsMacros.CommandValue.CheckboxPlaybackCommandValue.selectorGet, command._0);
    case /* SelectCommand */17 :
        return Curry._1(SelectCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* RadioCommand */18 :
        return Curry._1(RadioCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* MoveInputCursorCommand */22 :
        return Curry._1(MoveInputCursorCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* MoveContentEditableCursorCommand */23 :
        return Curry._1(MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* CopyLinkAddressCommand */25 :
        return Curry._1(CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* SelectionCommand */21 :
    case /* CopyCommand */24 :
    case /* CutCommand */26 :
        break;
    case /* PasteInInputCommand */27 :
        return Curry._1(PasteInInputCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* PasteInContentEditableCommand */28 :
        return Curry._1(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* DragCommand */29 :
    case /* DropCommand */30 :
        return [command._0];
    case /* ScrollCommand */31 :
        return ScrollCommand$SmartcutsMacros.CommandValue.selectorGet(command._0);
    case /* ContextMenuCommand */34 :
        return Curry._1(ContextMenuCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* LoopCommand */35 :
        return LoopCommand$SmartcutsMacros.CommandValue.selectorGet(command._0);
    case /* SwitchCommand */36 :
        var func = SwitchCommand$SmartcutsMacros.CommandValue.selectorGet;
        return Curry._2(func, selectorGet, command._0);
    case /* ScreenshotToClipboardCommand */37 :
        return Curry._1(ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* PasteImageInContentEditableCommand */38 :
        return Curry._1(PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* PasswordCommand */39 :
        return Curry._1(PasswordCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* ClickToOAuthCommand */40 :
        return Curry._1(ClickToOAuthCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* UploadCommand */41 :
        return UploadCommand$SmartcutsMacros.CommandValue.selectorGet(command._0);
    case /* CopyImageSrcCommand */42 :
        return Curry._1(CopyImageSrcCommand$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
    case /* WithElementGroupsCommand */43 :
        return [];
    default:
      return [];
  }
  return Curry._1(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.selectorGet, command._0);
}

function isFollowedBySubsequentNetworkLatency(command) {
  if (typeof command === "number") {
    switch (command) {
      case /* ReloadCommand */0 :
      case /* ForwardCommand */1 :
      case /* BackCommand */2 :
          return true;
      
    }
  } else {
    switch (command.TAG | 0) {
      case /* ClickCommand */12 :
          var match = Selector$SmartcutsMacros.maybeGetLeafNode(command._0.selector);
          if (match === undefined) {
            return false;
          }
          var s = match.innerText;
          if (typeof s === "number") {
            return false;
          }
          if (s.TAG !== /* FullInnerText */0) {
            return false;
          }
          var match$1 = $$String.lowercase_ascii(s._0);
          switch (match$1) {
            case "confirm" :
            case "create" :
            case "save" :
                return true;
            default:
              return false;
          }
      case /* NewWindowWithUrlCommand */1 :
      case /* NewTabWithUrlCommand */3 :
      case /* URLCommand */6 :
      case /* OpenedLinkCommand */7 :
      case /* SubmitFormCommand */8 :
      case /* SubmitFormRedirectCommand */9 :
      case /* ClientRedirectCommand */10 :
      case /* ServerRedirectCommand */11 :
      case /* ClickToOAuthCommand */40 :
      case /* UploadCommand */41 :
          return true;
      default:
        return false;
    }
  }
}

var ForPlayback = {
  Pack: Pack$2,
  isDownloadCommand: isDownloadCommand,
  isOpenedLinkCommand: isOpenedLinkCommand,
  isLoopCommand: isLoopCommand,
  selectorGet: selectorGet,
  isFollowedBySubsequentNetworkLatency: isFollowedBySubsequentNetworkLatency
};

function stringify(stringifyDomElementRepresentation, stringifyClickCommandValue, stringifyTypeCommandValue, stringifyFocusTabCommandValue, stringifyCheckboxCommandValue, stringifySelectCommandValue, stringifySelectionRelatedCommandValue, stringifyCopyLinkAddressCommandValue, stringifyPasteInInputCommandValue, stringifyPasteInContentEditableCommandValue, stringifyMoveInputCursorCommandValue, stringifyClickInputCommandValue, stringifyMoveContentEditableCursorCommandValue, stringifyClickContentEditableCommandValue, stringifyRadioCommandValue, stringifyDownloadCommandValue, stringifyGoogleSheetsCommandValue, stringifyContextMenuCommandValue, stringifyScreenshotToClipboardCommandValue, stringifyPasteImageInContentEditableCommandValue, stringifyPasswordCommandValue, stringifyClickToOAuthCommandValue, stringifyUploadCommandValue, stringifyCopyImageSrcCommandValue, stringifyWithElementGroupsCommandValue, command) {
  if (typeof command === "number") {
    switch (command) {
      case /* ReloadCommand */0 :
          return "ReloadCommand";
      case /* ForwardCommand */1 :
          return "ForwardCommand";
      case /* BackCommand */2 :
          return "BackCommand";
      
    }
  } else {
    switch (command.TAG | 0) {
      case /* NewWindowCommand */0 :
          return "NewWindowCommand(" + (NewWindowCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* NewWindowWithUrlCommand */1 :
          return "NewWindowWithUrlCommand(" + (NewWindowWithUrlCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* NewTabCommand */2 :
          return "NewTabCommand(" + (NewTabCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* NewTabWithUrlCommand */3 :
          return "NewTabWithUrlCommand(" + (NewTabWithUrlCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* CloseTabCommand */4 :
          return "CloseTabCommand(tabRef=" + (InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify(command._0) + ")");
      case /* FocusTabCommand */5 :
          return "FocusTabCommand(tabRef=" + (Curry._1(stringifyFocusTabCommandValue, command._0) + ")");
      case /* URLCommand */6 :
          return "URLCommand(" + (URLCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* OpenedLinkCommand */7 :
          return "OpenedLinkCommand(" + (OpenedLinkCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* SubmitFormCommand */8 :
          return "SubmitFormCommand(" + (SubmitFormCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* SubmitFormRedirectCommand */9 :
          return "SubmitFormRedirectCommand(" + (SubmitFormRedirectCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* ClientRedirectCommand */10 :
          return "ClientRedirectCommand(" + (ClientRedirectCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* ServerRedirectCommand */11 :
          return "ServerRedirectCommand(" + (ServerRedirectCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* ClickCommand */12 :
          return "ClickCommand(" + (Curry._1(stringifyClickCommandValue, command._0) + ")");
      case /* ClickInputCommand */13 :
          return "ClickInputCommand(" + (Curry._1(stringifyClickInputCommandValue, command._0) + ")");
      case /* ClickContentEditableCommand */14 :
          return "ClickContentEditableCommand(" + (Curry._1(stringifyClickContentEditableCommandValue, command._0) + ")");
      case /* TypeCommand */15 :
          return "TypeCommand(" + (Curry._1(stringifyTypeCommandValue, command._0) + ")");
      case /* CheckboxCommand */16 :
          return "CheckboxCommand(" + (Curry._1(stringifyCheckboxCommandValue, command._0) + ")");
      case /* SelectCommand */17 :
          return "SelectCommand(" + (Curry._1(stringifySelectCommandValue, command._0) + ")");
      case /* RadioCommand */18 :
          return "RadioCommand(" + (Curry._1(stringifyRadioCommandValue, command._0) + ")");
      case /* KeyCommand */19 :
          return "KeyCommand(" + (KeyCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* KeyComboCommand */20 :
          return "KeyComboCommand(" + (KeyComboCommand$SmartcutsMacros.CommandValue.stringify(command._0) + ")");
      case /* SelectionCommand */21 :
          return "SelectionCommand(" + (Curry._1(stringifySelectionRelatedCommandValue, command._0) + ")");
      case /* MoveInputCursorCommand */22 :
          return "MoveInputCursorCommand(" + (Curry._1(stringifyMoveInputCursorCommandValue, command._0) + ")");
      case /* MoveContentEditableCursorCommand */23 :
          return "MoveContentEditableCursorCommand(" + (Curry._1(stringifyMoveContentEditableCursorCommandValue, command._0) + ")");
      case /* CopyCommand */24 :
          return "CopyCommand(" + (Curry._1(stringifySelectionRelatedCommandValue, command._0) + ")");
      case /* CopyLinkAddressCommand */25 :
          return "CopyLinkAddressCommand(" + (Curry._1(stringifyCopyLinkAddressCommandValue, command._0) + ")");
      case /* CutCommand */26 :
          return "CutCommand(" + (Curry._1(stringifySelectionRelatedCommandValue, command._0) + ")");
      case /* PasteInInputCommand */27 :
          return "PasteInInputCommand(" + (Curry._1(stringifyPasteInInputCommandValue, command._0) + ")");
      case /* PasteInContentEditableCommand */28 :
          return "PasteInContentEditableCommand(" + (Curry._1(stringifyPasteInContentEditableCommandValue, command._0) + ")");
      case /* DragCommand */29 :
          return "DragCommand(domElement=" + (Curry._1(stringifyDomElementRepresentation, command._0) + ")");
      case /* DropCommand */30 :
          return "DropCommand(domElement=" + (Curry._1(stringifyDomElementRepresentation, command._0) + ")");
      case /* ScrollCommand */31 :
          return "ScrollCommand(delta(x, y))";
      case /* DownloadCommand */32 :
          return "DownloadCommand(" + (Curry._1(stringifyDownloadCommandValue, command._0) + ")");
      case /* GoogleSheetsCommand */33 :
          return "GoogleSheetsCommand(" + (Curry._1(stringifyGoogleSheetsCommandValue, command._0) + ")");
      case /* ContextMenuCommand */34 :
          return "ContextMenuCommand(" + (Curry._1(stringifyContextMenuCommandValue, command._0) + ")");
      case /* LoopCommand */35 :
          return "LoopCommand(" + LoopCommand$SmartcutsMacros.CommandValue.stringify(command._0);
      case /* SwitchCommand */36 :
          var func = SwitchCommand$SmartcutsMacros.CommandValue.stringify;
          return "SwitchCommand(" + Curry._2(func, (function (param) {
                        return stringify(stringifyDomElementRepresentation, stringifyClickCommandValue, stringifyTypeCommandValue, stringifyFocusTabCommandValue, stringifyCheckboxCommandValue, stringifySelectCommandValue, stringifySelectionRelatedCommandValue, stringifyCopyLinkAddressCommandValue, stringifyPasteInInputCommandValue, stringifyPasteInContentEditableCommandValue, stringifyMoveInputCursorCommandValue, stringifyClickInputCommandValue, stringifyMoveContentEditableCursorCommandValue, stringifyClickContentEditableCommandValue, stringifyRadioCommandValue, stringifyDownloadCommandValue, stringifyGoogleSheetsCommandValue, stringifyContextMenuCommandValue, stringifyScreenshotToClipboardCommandValue, stringifyPasteImageInContentEditableCommandValue, stringifyPasswordCommandValue, stringifyClickToOAuthCommandValue, stringifyUploadCommandValue, stringifyCopyImageSrcCommandValue, stringifyWithElementGroupsCommandValue, param);
                      }), command._0);
      case /* ScreenshotToClipboardCommand */37 :
          return "ScreenshotToClipboardCommand(" + (Curry._1(stringifyScreenshotToClipboardCommandValue, command._0) + ")");
      case /* PasteImageInContentEditableCommand */38 :
          return "PasteImageInContentEditableCommand(" + (Curry._1(stringifyPasteImageInContentEditableCommandValue, command._0) + ")");
      case /* PasswordCommand */39 :
          return "PasswordCommand(" + (Curry._1(stringifyPasswordCommandValue, command._0) + ")");
      case /* ClickToOAuthCommand */40 :
          return "ClickToOAuthCommand(" + (Curry._1(stringifyClickToOAuthCommandValue, command._0) + ")");
      case /* UploadCommand */41 :
          return "UploadCommand(" + (Curry._1(stringifyUploadCommandValue, command._0) + ")");
      case /* CopyImageSrcCommand */42 :
          return "CopyImageSrcCommand(" + (Curry._1(stringifyCopyImageSrcCommandValue, command._0) + ")");
      case /* WithElementGroupsCommand */43 :
          return "WithElementGroupsCommand(" + (Curry._1(stringifyWithElementGroupsCommandValue, command._0) + ")");
      
    }
  }
}

function stringifyRecordingCommand(param) {
  return stringify((function (param) {
                return "(domElementIdentifier=" + (String(param.domElementIdentifier) + (", selector=" + (Selector$SmartcutsMacros.stringify(undefined, false, param.selector) + ")")));
              }), ClickCommand$SmartcutsMacros.CommandValue.Recording.stringify, TypeCommand$SmartcutsMacros.CommandValue.Recording.stringify, (function (param) {
                return PromisedValue$SmartcutsMacros.stringify(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify, PromisedValue$SmartcutsMacros.PendingPlaceholderForRecording.stringify, param);
              }), CheckboxCommand$SmartcutsMacros.CommandValue.Recording.stringify, SelectCommand$SmartcutsMacros.CommandValue.Recording.stringify, SelectionRelatedCommands$SmartcutsMacros.CommandValue.Recording.stringify, CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Recording.stringify, PasteInInputCommand$SmartcutsMacros.CommandValue.Recording.stringify, PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Recording.stringify, MoveInputCursorCommand$SmartcutsMacros.CommandValue.Recording.stringify, ClickInputCommand$SmartcutsMacros.CommandValue.Recording.stringify, MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Recording.stringify, ClickContentEditableCommand$SmartcutsMacros.CommandValue.Recording.stringify, RadioCommand$SmartcutsMacros.CommandValue.Recording.stringify, DownloadCommand$SmartcutsMacros.CommandValue.Recording.stringify, GoogleSheetsCommand$SmartcutsMacros.CommandValue.Recording.stringify, ContextMenuCommand$SmartcutsMacros.CommandValue.Recording.stringify, ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Recording.stringify, PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Recording.stringify, PasswordCommand$SmartcutsMacros.CommandValue.Recording.stringify, ClickToOAuthCommand$SmartcutsMacros.CommandValue.Recording.stringify, UploadCommand$SmartcutsMacros.CommandValue.Recording.stringify, CopyImageSrcCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.stringify, WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.stringify, param);
}

function stringifyAuthoringCommand(param) {
  return stringify((function (selector) {
                return Selector$SmartcutsMacros.stringify(undefined, false, selector);
              }), ClickCommand$SmartcutsMacros.CommandValue.Authoring.stringify, TypeCommand$SmartcutsMacros.CommandValue.Authoring.stringify, (function (param) {
                return FocusTabCommand$SmartcutsMacros.CommandValue.stringify(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify, param);
              }), CheckboxCommand$SmartcutsMacros.CommandValue.Authoring.stringify, SelectCommand$SmartcutsMacros.CommandValue.Authoring.stringify, SelectionRelatedCommands$SmartcutsMacros.CommandValue.Authoring.stringify, CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Authoring.stringify, PasteInInputCommand$SmartcutsMacros.CommandValue.Authoring.stringify, PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.stringify, MoveInputCursorCommand$SmartcutsMacros.CommandValue.Authoring.stringify, ClickInputCommand$SmartcutsMacros.CommandValue.Authoring.stringify, MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Authoring.stringify, ClickContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.stringify, RadioCommand$SmartcutsMacros.CommandValue.Authoring.stringify, DownloadCommand$SmartcutsMacros.CommandValue.Authoring.stringify, GoogleSheetsCommand$SmartcutsMacros.CommandValue.Authoring.stringify, ContextMenuCommand$SmartcutsMacros.CommandValue.Authoring.stringify, ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Authoring.stringify, PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.stringify, PasswordCommand$SmartcutsMacros.CommandValue.Authoring.stringify, ClickToOAuthCommand$SmartcutsMacros.CommandValue.Authoring.stringify, UploadCommand$SmartcutsMacros.CommandValue.Authoring.stringify, CopyImageSrcCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.stringify, WithElementGroupsCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.stringify, param);
}

function stringifyPlaybackCommand(param) {
  return stringify((function (selector) {
                return Selector$SmartcutsMacros.stringify(undefined, false, selector);
              }), ClickCommand$SmartcutsMacros.CommandValue.Playback.stringify, TypeCommand$SmartcutsMacros.CommandValue.Playback.stringify, (function (param) {
                return FocusTabCommand$SmartcutsMacros.CommandValue.stringify(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.stringify, param);
              }), CheckboxCommand$SmartcutsMacros.CommandValue.Playback.stringify, SelectCommand$SmartcutsMacros.CommandValue.Playback.stringify, SelectionRelatedCommands$SmartcutsMacros.CommandValue.Playback.stringify, CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Playback.stringify, PasteInInputCommand$SmartcutsMacros.CommandValue.Playback.stringify, PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.stringify, MoveInputCursorCommand$SmartcutsMacros.CommandValue.Playback.stringify, ClickInputCommand$SmartcutsMacros.CommandValue.Playback.stringify, MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Playback.stringify, ClickContentEditableCommand$SmartcutsMacros.CommandValue.Playback.stringify, RadioCommand$SmartcutsMacros.CommandValue.Playback.stringify, DownloadCommand$SmartcutsMacros.CommandValue.Playback.stringify, GoogleSheetsCommand$SmartcutsMacros.CommandValue.Playback.stringify, ContextMenuCommand$SmartcutsMacros.CommandValue.Playback.stringify, ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Playback.stringify, PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Playback.stringify, PasswordCommand$SmartcutsMacros.CommandValue.Playback.stringify, ClickToOAuthCommand$SmartcutsMacros.CommandValue.Playback.stringify, UploadCommand$SmartcutsMacros.CommandValue.Playback.stringify, CopyImageSrcCommand$SmartcutsMacros.CommandValue.Playback.stringify, WithElementGroupsCommand$SmartcutsMacros.CommandValue.Playback.stringify, param);
}

function updateSelectorInAuthoringCommand(f, command) {
  if (typeof command === "number") {
    return command;
  }
  switch (command.TAG | 0) {
    case /* ClickCommand */12 :
        var func = ClickCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector;
        return {
                TAG: /* ClickCommand */12,
                _0: Curry._2(func, f, command._0)
              };
    case /* ClickInputCommand */13 :
        var commandValue = command._0;
        var inputCursorWithSemantics = commandValue.inputCursorWithSemantics;
        return {
                TAG: /* ClickInputCommand */13,
                _0: {
                  inputCursorWithSemantics: {
                    inputCursor: Selection__InputCursor$SmartcutsMacros.ForNonRecording.updateSelector(f, inputCursorWithSemantics.inputCursor),
                    semantics: inputCursorWithSemantics.semantics
                  },
                  positionRelToElement: commandValue.positionRelToElement,
                  label: commandValue.label
                }
              };
    case /* ClickContentEditableCommand */14 :
        return {
                TAG: /* ClickContentEditableCommand */14,
                _0: Curry._2(ClickContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
              };
    case /* TypeCommand */15 :
        return {
                TAG: /* TypeCommand */15,
                _0: Curry._2(TypeCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
              };
    case /* SelectCommand */17 :
        return {
                TAG: /* SelectCommand */17,
                _0: Curry._2(SelectCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
              };
    case /* RadioCommand */18 :
        return {
                TAG: /* RadioCommand */18,
                _0: Curry._2(RadioCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
              };
    case /* SelectionCommand */21 :
        return {
                TAG: /* SelectionCommand */21,
                _0: Curry._2(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
              };
    case /* MoveInputCursorCommand */22 :
        return {
                TAG: /* MoveInputCursorCommand */22,
                _0: Curry._2(MoveInputCursorCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
              };
    case /* MoveContentEditableCursorCommand */23 :
        return {
                TAG: /* MoveContentEditableCursorCommand */23,
                _0: Curry._2(MoveContentEditableCursorCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
              };
    case /* CopyCommand */24 :
        return {
                TAG: /* CopyCommand */24,
                _0: Curry._2(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
              };
    case /* CopyLinkAddressCommand */25 :
        return {
                TAG: /* CopyLinkAddressCommand */25,
                _0: Curry._2(CopyLinkAddressCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
              };
    case /* CutCommand */26 :
        return {
                TAG: /* CutCommand */26,
                _0: Curry._2(SelectionRelatedCommands$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
              };
    case /* PasteInInputCommand */27 :
        return {
                TAG: /* PasteInInputCommand */27,
                _0: Curry._2(PasteInInputCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
              };
    case /* PasteInContentEditableCommand */28 :
        return {
                TAG: /* PasteInContentEditableCommand */28,
                _0: Curry._2(PasteInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
              };
    case /* DragCommand */29 :
        return {
                TAG: /* DragCommand */29,
                _0: Curry._1(f, command._0)
              };
    case /* DropCommand */30 :
        return {
                TAG: /* DropCommand */30,
                _0: Curry._1(f, command._0)
              };
    case /* ContextMenuCommand */34 :
        var commandValue$1 = command._0;
        return {
                TAG: /* ContextMenuCommand */34,
                _0: {
                  selector: Curry._1(f, commandValue$1.selector),
                  viewportPosition: commandValue$1.viewportPosition,
                  positionRelToElement: commandValue$1.positionRelToElement,
                  maybeSubPathToImg: commandValue$1.maybeSubPathToImg
                }
              };
    case /* LoopCommand */35 :
        var func$1 = LoopCommand$SmartcutsMacros.CommandValue.mapSelector;
        return {
                TAG: /* LoopCommand */35,
                _0: Curry._2(func$1, f, command._0)
              };
    case /* SwitchCommand */36 :
        var func$2 = SwitchCommand$SmartcutsMacros.CommandValue.mapSelector;
        var func$3 = Curry._1(func$2, f);
        return {
                TAG: /* SwitchCommand */36,
                _0: Curry._2(func$3, (function (commandWithContext) {
                        return {
                                id: commandWithContext.id,
                                command: updateSelectorInAuthoringCommand(f, commandWithContext.command),
                                contextGlobal: commandWithContext.contextGlobal
                              };
                      }), command._0)
              };
    case /* ScreenshotToClipboardCommand */37 :
        var func$4 = ScreenshotToClipboardCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector;
        return {
                TAG: /* ScreenshotToClipboardCommand */37,
                _0: Curry._2(func$4, f, command._0)
              };
    case /* PasteImageInContentEditableCommand */38 :
        var func$5 = PasteImageInContentEditableCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector;
        return {
                TAG: /* PasteImageInContentEditableCommand */38,
                _0: Curry._2(func$5, f, command._0)
              };
    case /* PasswordCommand */39 :
        return {
                TAG: /* PasswordCommand */39,
                _0: Curry._2(PasswordCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
              };
    case /* ClickToOAuthCommand */40 :
        return {
                TAG: /* ClickToOAuthCommand */40,
                _0: Curry._2(ClickToOAuthCommand$SmartcutsMacros.CommandValue.Authoring.updateSelector, f, command._0)
              };
    case /* UploadCommand */41 :
        return {
                TAG: /* UploadCommand */41,
                _0: UploadCommand$SmartcutsMacros.CommandValue.mapSelector(f, command._0)
              };
    case /* CopyImageSrcCommand */42 :
        return {
                TAG: /* CopyImageSrcCommand */42,
                _0: Curry._2(CopyImageSrcCommand$SmartcutsMacros.CommandValue.RecordingAndAuthoring.updateSelector, f, command._0)
              };
    case /* WithElementGroupsCommand */43 :
        return {
                TAG: /* WithElementGroupsCommand */43,
                _0: command._0
              };
    default:
      return command;
  }
}

function t_encode$1(v) {
  return Js_dict.fromArray([
              [
                "command",
                recordingCommand_encode(v.command)
              ],
              [
                "contextLocal",
                CommandContext$SmartcutsMacros.commandContextLocal_encode(v.contextLocal)
              ]
            ]);
}

function t_decode$1(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var command = recordingCommand_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "command"), null));
  if (command.TAG === /* Ok */0) {
    var contextLocal = CommandContext$SmartcutsMacros.commandContextLocal_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "contextLocal"), null));
    if (contextLocal.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                command: command._0,
                contextLocal: contextLocal._0
              }
            };
    }
    var e = contextLocal._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".contextLocal" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = command._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".command" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function stringify$1(param) {
  return "{command: " + (stringifyRecordingCommand(param.command) + ", contextLocal}");
}

var CommandWithContextLocal = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1
};

function t_encode$2(v) {
  return Js_dict.fromArray([
              [
                "id",
                Decco.intToJson(v.id)
              ],
              [
                "command",
                recordingCommand_encode(v.command)
              ],
              [
                "contextGlobal",
                CommandContext$SmartcutsMacros.CommandContextGlobalPromised.t_encode(v.contextGlobal)
              ]
            ]);
}

function t_decode$2(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var id = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "id"), null));
  if (id.TAG === /* Ok */0) {
    var command = recordingCommand_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "command"), null));
    if (command.TAG === /* Ok */0) {
      var contextGlobal = CommandContext$SmartcutsMacros.CommandContextGlobalPromised.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "contextGlobal"), null));
      if (contextGlobal.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  id: id._0,
                  command: command._0,
                  contextGlobal: contextGlobal._0
                }
              };
      }
      var e = contextGlobal._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".contextGlobal" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = command._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".command" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = id._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".id" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function minify(param) {
  return {
          id: param.id,
          command: param.command,
          contextGlobal: CommandContext$SmartcutsMacros.CommandContextGlobalPromised.minify(param.contextGlobal)
        };
}

function calcSize(unit, commandWithContext) {
  return StringUtils$SmartcutsMacros.byteSize(unit, JSON.stringify(t_encode$2(commandWithContext)));
}

function getMaybeDevicePixelRatio(param) {
  return CommandContext$SmartcutsMacros.CommandContextGlobalPromised.getMaybeDevicePixelRatio(param.contextGlobal);
}

function getMaybeResolvedTabRefAndWindowRef(param) {
  var contextGlobal = param.contextGlobal;
  var tabRef = contextGlobal.tabRef;
  if (tabRef.TAG === /* Resolved */0) {
    return [
            tabRef._0,
            contextGlobal.windowRef
          ];
  }
  
}

var CommandWithContextGlobalForRecording = {
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  minify: minify,
  calcSize: calcSize,
  getMaybeDevicePixelRatio: getMaybeDevicePixelRatio,
  getMaybeResolvedTabRefAndWindowRef: getMaybeResolvedTabRefAndWindowRef
};

function t_encode$3(v) {
  return GenericCommandWithContextGlobal$SmartcutsMacros.t_encode(recordingCommand_encode, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode, v);
}

function t_decode$3(v) {
  return GenericCommandWithContextGlobal$SmartcutsMacros.t_decode(recordingCommand_decode, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_decode, v);
}

function fromCommandWithContextGlobalForRecording(param) {
  return {
          id: param.id,
          command: param.command,
          contextGlobal: CommandContext$SmartcutsMacros.CommandContextGlobalResolved.fromCommandContextGlobalPromised(param.contextGlobal)
        };
}

function minify$1(param) {
  return {
          id: param.id,
          command: param.command,
          contextGlobal: CommandContext$SmartcutsMacros.CommandContextGlobalResolved.minify(param.contextGlobal)
        };
}

function calcSize$1(unit, param) {
  return StringUtils$SmartcutsMacros.byteSize(unit, JSON.stringify(recordingCommand_encode(param.command))) + StringUtils$SmartcutsMacros.byteSize(unit, JSON.stringify(CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode(param.contextGlobal))) | 0;
}

function toGraphql(index, cmdWithContext) {
  return {
          index: index,
          recordedSmartcut: undefined,
          commandSerialized: JSON.stringify(recordingCommand_encode(cmdWithContext.command)),
          contextSerialized: JSON.stringify(CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode(CommandContext$SmartcutsMacros.CommandContextGlobalResolved.minify(cmdWithContext.contextGlobal))),
          schemaVersion: schemaVersion,
          size: calcSize$1(/* Kilobytes */1, cmdWithContext)
        };
}

var CommandWithContextGlobalForRecordingResolved = {
  t_encode: t_encode$3,
  t_decode: t_decode$3,
  fromCommandWithContextGlobalForRecording: fromCommandWithContextGlobalForRecording,
  minify: minify$1,
  calcSize: calcSize$1,
  toGraphql: toGraphql
};

function t_encode$4(v) {
  return GenericCommandWithContextGlobal$SmartcutsMacros.t_encode(authoringCommand_encode, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode, v);
}

function t_decode$4(v) {
  return GenericCommandWithContextGlobal$SmartcutsMacros.t_decode(authoringCommand_decode, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_decode, v);
}

function minify$2(param) {
  return {
          id: param.id,
          command: param.command,
          contextGlobal: CommandContext$SmartcutsMacros.CommandContextGlobalResolved.minify(param.contextGlobal)
        };
}

function calcSize$2(unit, param) {
  return StringUtils$SmartcutsMacros.byteSize(unit, JSON.stringify(authoringCommand_encode(param.command))) + StringUtils$SmartcutsMacros.byteSize(unit, JSON.stringify(CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode(param.contextGlobal))) | 0;
}

function toGraphql$1(index, cmdWithContext) {
  return {
          index: index,
          recordedSmartcut: undefined,
          commandSerialized: JSON.stringify(authoringCommand_encode(cmdWithContext.command)),
          contextSerialized: JSON.stringify(CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode(CommandContext$SmartcutsMacros.CommandContextGlobalResolved.minify(cmdWithContext.contextGlobal))),
          schemaVersion: schemaVersion,
          size: calcSize$2(/* Kilobytes */1, cmdWithContext)
        };
}

var CommandWithContextGlobalForAuthoring = {
  t_encode: t_encode$4,
  t_decode: t_decode$4,
  minify: minify$2,
  calcSize: calcSize$2,
  toGraphql: toGraphql$1
};

function t_encode$5(v) {
  return GenericCommandWithContextGlobal$SmartcutsMacros.t_encode(playbackCommand_encode, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode, v);
}

function t_decode$5(v) {
  return GenericCommandWithContextGlobal$SmartcutsMacros.t_decode(playbackCommand_decode, CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_decode, v);
}

function calcSize$3(unit, param) {
  return StringUtils$SmartcutsMacros.byteSize(unit, JSON.stringify(playbackCommand_encode(param.command))) + StringUtils$SmartcutsMacros.byteSize(unit, JSON.stringify(CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode(param.contextGlobal))) | 0;
}

function minify$3(param) {
  return {
          id: param.id,
          command: param.command,
          contextGlobal: CommandContext$SmartcutsMacros.CommandContextGlobalResolved.minify(param.contextGlobal)
        };
}

function rehydrate(commandWithContext) {
  return CommandContext$SmartcutsMacros.CommandContextGlobalResolved.rehydrate(commandWithContext.contextGlobal).then(function (rehydratedeContextGlobal) {
              return Promise.resolve({
                          id: commandWithContext.id,
                          command: commandWithContext.command,
                          contextGlobal: rehydratedeContextGlobal
                        });
            });
}

function toGraphql$2(index, cmdWithContext) {
  return {
          index: index,
          recordedSmartcut: undefined,
          commandSerialized: JSON.stringify(playbackCommand_encode(cmdWithContext.command)),
          contextSerialized: JSON.stringify(CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode(cmdWithContext.contextGlobal)),
          schemaVersion: schemaVersion,
          size: calcSize$3(/* Kilobytes */1, cmdWithContext)
        };
}

function toGraphqlPartialUpdate(cmdWithContext) {
  return {
          commandSerialized: JSON.stringify(playbackCommand_encode(cmdWithContext.command)),
          contextSerialized: JSON.stringify(CommandContext$SmartcutsMacros.CommandContextGlobalResolved.t_encode(cmdWithContext.contextGlobal)),
          schemaVersion: schemaVersion,
          size: calcSize$3(/* Kilobytes */1, cmdWithContext)
        };
}

function maybeSubstituteUrlFromCompletedCommandWithContextGlobal(completedCommandWithContextGlobal, commandWithContextGlobal) {
  var match = completedCommandWithContextGlobal.command;
  var exit = 0;
  var urlFromCompletedCommand;
  var tabRefFromCompletedCommand;
  if (typeof match === "number") {
    return commandWithContextGlobal;
  }
  switch (match.TAG | 0) {
    case /* NewWindowWithUrlCommand */1 :
    case /* NewTabWithUrlCommand */3 :
        exit = 1;
        break;
    case /* URLCommand */6 :
        var match$1 = match._0;
        urlFromCompletedCommand = match$1.url;
        tabRefFromCompletedCommand = match$1.tabRef;
        exit = 2;
        break;
    case /* OpenedLinkCommand */7 :
        var match$2 = match._0;
        urlFromCompletedCommand = match$2.url;
        tabRefFromCompletedCommand = match$2.tabRef;
        exit = 2;
        break;
    default:
      return commandWithContextGlobal;
  }
  switch (exit) {
    case 1 :
        if (!(Caml_obj.caml_equal(commandWithContextGlobal.contextGlobal.tabRef.recordingId, completedCommandWithContextGlobal.contextGlobal.tabRef.recordingId) && commandWithContextGlobal.contextGlobal.url === completedCommandWithContextGlobal.contextGlobal.url)) {
          return commandWithContextGlobal;
        }
        var init = commandWithContextGlobal.contextGlobal;
        return {
                id: commandWithContextGlobal.id,
                command: commandWithContextGlobal.command,
                contextGlobal: {
                  windowRef: init.windowRef,
                  tabRef: init.tabRef,
                  url: match._0.url,
                  focusStatus: init.focusStatus,
                  title: init.title,
                  frame: init.frame,
                  windowGeometry: init.windowGeometry,
                  targetBoundingRect: init.targetBoundingRect,
                  timestamp: init.timestamp,
                  htmlSnapshot: init.htmlSnapshot,
                  screenshot: init.screenshot,
                  croppedScreenshot: init.croppedScreenshot,
                  preconditions: init.preconditions,
                  maybeLogoutLocator: init.maybeLogoutLocator
                }
              };
    case 2 :
        if (!(Caml_obj.caml_equal(commandWithContextGlobal.contextGlobal.tabRef.recordingId, tabRefFromCompletedCommand.recordingId) && commandWithContextGlobal.contextGlobal.url === completedCommandWithContextGlobal.contextGlobal.url)) {
          return commandWithContextGlobal;
        }
        var init$1 = commandWithContextGlobal.contextGlobal;
        return {
                id: commandWithContextGlobal.id,
                command: commandWithContextGlobal.command,
                contextGlobal: {
                  windowRef: init$1.windowRef,
                  tabRef: init$1.tabRef,
                  url: urlFromCompletedCommand,
                  focusStatus: init$1.focusStatus,
                  title: init$1.title,
                  frame: init$1.frame,
                  windowGeometry: init$1.windowGeometry,
                  targetBoundingRect: init$1.targetBoundingRect,
                  timestamp: init$1.timestamp,
                  htmlSnapshot: init$1.htmlSnapshot,
                  screenshot: init$1.screenshot,
                  croppedScreenshot: init$1.croppedScreenshot,
                  preconditions: init$1.preconditions,
                  maybeLogoutLocator: init$1.maybeLogoutLocator
                }
              };
    
  }
}

function substituteTabIdInCommandWithContextGlobal(tabIdToReplace, newTabId, commandWithContextGlobal) {
  var contextGlobal = commandWithContextGlobal.contextGlobal;
  var command = commandWithContextGlobal.command;
  var newCommand;
  if (typeof command === "number") {
    newCommand = command;
  } else {
    switch (command.TAG | 0) {
      case /* NewTabCommand */2 :
          var match = command._0;
          var tabRef = match.tabRef;
          newCommand = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(tabIdToReplace, tabRef) ? ({
                TAG: /* NewTabCommand */2,
                _0: {
                  tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(newTabId, tabRef),
                  windowRef: match.windowRef,
                  focusStatus: match.focusStatus
                }
              }) : command;
          break;
      case /* NewTabWithUrlCommand */3 :
          var match$1 = command._0;
          var tabRef$1 = match$1.tabRef;
          newCommand = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(tabIdToReplace, tabRef$1) ? ({
                TAG: /* NewTabWithUrlCommand */3,
                _0: {
                  url: match$1.url,
                  title: match$1.title,
                  tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(newTabId, tabRef$1),
                  windowRef: match$1.windowRef,
                  focusStatus: match$1.focusStatus
                }
              }) : command;
          break;
      case /* CloseTabCommand */4 :
          var tabRef$2 = command._0;
          newCommand = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(tabIdToReplace, tabRef$2) ? ({
                TAG: /* CloseTabCommand */4,
                _0: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(newTabId, tabRef$2)
              }) : command;
          break;
      case /* FocusTabCommand */5 :
          var commandValue = command._0;
          var tabRef$3 = commandValue.tabRef;
          newCommand = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(tabIdToReplace, tabRef$3) ? ({
                TAG: /* FocusTabCommand */5,
                _0: {
                  tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(newTabId, tabRef$3),
                  url: commandValue.url,
                  title: commandValue.title
                }
              }) : command;
          break;
      case /* URLCommand */6 :
          var match$2 = command._0;
          var tabRef$4 = match$2.tabRef;
          newCommand = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(tabIdToReplace, tabRef$4) ? ({
                TAG: /* URLCommand */6,
                _0: {
                  url: match$2.url,
                  title: match$2.title,
                  tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(newTabId, tabRef$4)
                }
              }) : command;
          break;
      case /* OpenedLinkCommand */7 :
          var cmdVal = command._0;
          var openerTabRef = cmdVal.maybeOpenerTab;
          var tabRef$5 = cmdVal.tabRef;
          newCommand = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(tabIdToReplace, tabRef$5) ? ({
                TAG: /* OpenedLinkCommand */7,
                _0: {
                  tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(newTabId, tabRef$5),
                  windowRef: cmdVal.windowRef,
                  url: cmdVal.url,
                  title: cmdVal.title,
                  maybeOpenerTab: cmdVal.maybeOpenerTab,
                  viaHistoryApi: cmdVal.viaHistoryApi
                }
              }) : (
              openerTabRef !== undefined && InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId(tabIdToReplace, openerTabRef) ? ({
                    TAG: /* OpenedLinkCommand */7,
                    _0: {
                      tabRef: cmdVal.tabRef,
                      windowRef: cmdVal.windowRef,
                      url: cmdVal.url,
                      title: cmdVal.title,
                      maybeOpenerTab: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(newTabId, openerTabRef),
                      viaHistoryApi: cmdVal.viaHistoryApi
                    }
                  }) : command
            );
          break;
      case /* DownloadCommand */32 :
          newCommand = {
            TAG: /* DownloadCommand */32,
            _0: Curry._3(DownloadCommand$SmartcutsMacros.CommandValue.Playback.maybeAssignPlaybackTabId, tabIdToReplace, newTabId, command._0)
          };
          break;
      case /* SwitchCommand */36 :
          var func = SwitchCommand$SmartcutsMacros.CommandValue.map;
          newCommand = {
            TAG: /* SwitchCommand */36,
            _0: Curry._2(func, (function (param) {
                    return substituteTabIdInCommandWithContextGlobal(tabIdToReplace, newTabId, param);
                  }), command._0)
          };
          break;
      default:
        newCommand = command;
    }
  }
  var func$1 = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.equalsRecordingTabId;
  var arg = contextGlobal.tabRef;
  var newContextGlobal = (function (param) {
        return Curry._2(func$1, param, arg);
      })(tabIdToReplace) ? ({
        windowRef: contextGlobal.windowRef,
        tabRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.assignPlaybackTabId(newTabId, contextGlobal.tabRef),
        url: contextGlobal.url,
        focusStatus: contextGlobal.focusStatus,
        title: contextGlobal.title,
        frame: contextGlobal.frame,
        windowGeometry: contextGlobal.windowGeometry,
        targetBoundingRect: contextGlobal.targetBoundingRect,
        timestamp: contextGlobal.timestamp,
        htmlSnapshot: contextGlobal.htmlSnapshot,
        screenshot: contextGlobal.screenshot,
        croppedScreenshot: contextGlobal.croppedScreenshot,
        preconditions: contextGlobal.preconditions,
        maybeLogoutLocator: contextGlobal.maybeLogoutLocator
      }) : contextGlobal;
  return {
          id: commandWithContextGlobal.id,
          command: newCommand,
          contextGlobal: newContextGlobal
        };
}

function maybeCreatedWindow(param) {
  var match = param.contextGlobal;
  var tabRef = match.tabRef;
  var windowRef = match.windowRef;
  var tmp = param.command;
  if (typeof tmp === "number") {
    return ;
  }
  switch (tmp.TAG | 0) {
    case /* NewWindowCommand */0 :
    case /* NewWindowWithUrlCommand */1 :
        return [
                windowRef,
                tabRef
              ];
    default:
      return ;
  }
}

function maybeCreatedTab(param) {
  var contextGlobal = param.contextGlobal;
  var command = param.command;
  if (typeof command === "number") {
    return ;
  }
  switch (command.TAG | 0) {
    case /* NewTabCommand */2 :
        return command._0.tabRef;
    case /* NewTabWithUrlCommand */3 :
        return command._0.tabRef;
    case /* OpenedLinkCommand */7 :
        var match = command._0;
        if (match.maybeOpenerTab !== undefined && !match.viaHistoryApi) {
          return match.tabRef;
        } else {
          return ;
        }
    case /* NewWindowCommand */0 :
    case /* NewWindowWithUrlCommand */1 :
    case /* ServerRedirectCommand */11 :
        return contextGlobal.tabRef;
    case /* DownloadCommand */32 :
        var match$1 = command._0.tabOrigin;
        if (match$1.TAG === /* DownloadInNewTab */0) {
          return match$1._0.newTab;
        } else {
          return ;
        }
    default:
      return ;
  }
}

function substituteWindowIdInCommandWithContextGlobal(windowIdToReplace, newWindowId, commandWithContextGlobal) {
  var contextGlobal = commandWithContextGlobal.contextGlobal;
  var command = commandWithContextGlobal.command;
  var newCommand;
  if (typeof command === "number") {
    newCommand = command;
  } else {
    switch (command.TAG | 0) {
      case /* NewWindowCommand */0 :
          var match = command._0;
          var windowRef = match.windowRef;
          newCommand = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.equalsRecordingWindowId(windowIdToReplace, windowRef) ? ({
                TAG: /* NewWindowCommand */0,
                _0: {
                  windowRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.assignPlaybackWindowId(newWindowId, windowRef),
                  focusStatus: match.focusStatus
                }
              }) : command;
          break;
      case /* NewTabCommand */2 :
          var match$1 = command._0;
          var windowRef$1 = match$1.windowRef;
          newCommand = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.equalsRecordingWindowId(windowIdToReplace, windowRef$1) ? ({
                TAG: /* NewTabCommand */2,
                _0: {
                  tabRef: match$1.tabRef,
                  windowRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.assignPlaybackWindowId(newWindowId, windowRef$1),
                  focusStatus: match$1.focusStatus
                }
              }) : command;
          break;
      case /* NewTabWithUrlCommand */3 :
          var match$2 = command._0;
          var windowRef$2 = match$2.windowRef;
          newCommand = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.equalsRecordingWindowId(windowIdToReplace, windowRef$2) ? ({
                TAG: /* NewTabWithUrlCommand */3,
                _0: {
                  url: match$2.url,
                  title: match$2.title,
                  tabRef: match$2.tabRef,
                  windowRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.assignPlaybackWindowId(newWindowId, windowRef$2),
                  focusStatus: match$2.focusStatus
                }
              }) : command;
          break;
      case /* SwitchCommand */36 :
          var func = SwitchCommand$SmartcutsMacros.CommandValue.map;
          newCommand = {
            TAG: /* SwitchCommand */36,
            _0: Curry._2(func, (function (param) {
                    return substituteWindowIdInCommandWithContextGlobal(windowIdToReplace, newWindowId, param);
                  }), command._0)
          };
          break;
      default:
        newCommand = command;
    }
  }
  var newContextGlobal = InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.equalsRecordingWindowId(windowIdToReplace, contextGlobal.windowRef) ? ({
        windowRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.assignPlaybackWindowId(newWindowId, contextGlobal.windowRef),
        tabRef: contextGlobal.tabRef,
        url: contextGlobal.url,
        focusStatus: contextGlobal.focusStatus,
        title: contextGlobal.title,
        frame: contextGlobal.frame,
        windowGeometry: contextGlobal.windowGeometry,
        targetBoundingRect: contextGlobal.targetBoundingRect,
        timestamp: contextGlobal.timestamp,
        htmlSnapshot: contextGlobal.htmlSnapshot,
        screenshot: contextGlobal.screenshot,
        croppedScreenshot: contextGlobal.croppedScreenshot,
        preconditions: contextGlobal.preconditions,
        maybeLogoutLocator: contextGlobal.maybeLogoutLocator
      }) : contextGlobal;
  return {
          id: commandWithContextGlobal.id,
          command: newCommand,
          contextGlobal: newContextGlobal
        };
}

function getGoogleSheetOutputUrl(param) {
  var command = param.command;
  if (typeof command === "number") {
    return ;
  }
  switch (command.TAG | 0) {
    case /* GoogleSheetsCommand */33 :
        return param.contextGlobal.url;
    case /* WithElementGroupsCommand */43 :
        return ArrayUtils$SmartcutsMacros.shortcut((function (action) {
                      var destination = action._0.destination;
                      if (destination.TAG === /* ExistingGoogleSheet */0) {
                        return destination._0.spreadsheetUrl;
                      }
                      var googleSheet = destination._0;
                      if (googleSheet.TAG === /* Resolved */0) {
                        return googleSheet._0.spreadsheetUrl;
                      }
                      
                    }), command._0.actions);
    default:
      return ;
  }
}

var CommandWithContextGlobalForPlayback = {
  t_encode: t_encode$5,
  t_decode: t_decode$5,
  calcSize: calcSize$3,
  minify: minify$3,
  rehydrate: rehydrate,
  toGraphql: toGraphql$2,
  toGraphqlPartialUpdate: toGraphqlPartialUpdate,
  maybeSubstituteUrlFromCompletedCommandWithContextGlobal: maybeSubstituteUrlFromCompletedCommandWithContextGlobal,
  substituteTabIdInCommandWithContextGlobal: substituteTabIdInCommandWithContextGlobal,
  maybeCreatedWindow: maybeCreatedWindow,
  maybeCreatedTab: maybeCreatedTab,
  substituteWindowIdInCommandWithContextGlobal: substituteWindowIdInCommandWithContextGlobal,
  getGoogleSheetOutputUrl: getGoogleSheetOutputUrl
};

function decorateCommandWithGlobalContext(commandId, tab, tabId, focusStatus, screenshot, croppedScreenshotOpt, preconditions, maybeLogoutLocator, cmd) {
  var croppedScreenshot = croppedScreenshotOpt !== undefined ? croppedScreenshotOpt : /* NoImage */0;
  var windowId = tab.windowId;
  var width = tab.width;
  var height = tab.height;
  return {
          id: commandId,
          command: cmd,
          contextGlobal: {
            windowRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.makeFromRecordingWindowId(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.makeRecordingId(windowId)),
            tabRef: {
              TAG: /* Resolved */0,
              _0: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.makeFromRecordingTabId(tabId)
            },
            url: {
              TAG: /* Resolved */0,
              _0: OptionUtils$SmartcutsMacros.getExn("Undefined tab url during Command.decorateCommandWithGlobalContext", tab.url)
            },
            focusStatus: focusStatus,
            title: {
              TAG: /* Resolved */0,
              _0: tab.title
            },
            frame: {
              TAG: /* Resolved */0,
              _0: {
                TAG: /* TopFrame */0,
                _0: "TODO"
              }
            },
            windowGeometry: {
              TAG: /* Resolved */0,
              _0: {
                width: width !== undefined ? width : Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: no width"),
                height: height !== undefined ? height : Util$SmartcutsMacros.logAndRaiseJsError("Unexpected: no height"),
                zoomFactor: 1.0,
                devicePixelRatio: {
                  TAG: /* FromBgScript */1,
                  _0: window.devicePixelRatio
                }
              }
            },
            targetBoundingRect: undefined,
            timestamp: Date.now(),
            htmlSnapshot: "TODO",
            screenshot: screenshot,
            croppedScreenshot: croppedScreenshot,
            preconditions: preconditions,
            maybeLogoutLocator: maybeLogoutLocator
          }
        };
}

function decorateCommandWithLocalContextWithGlobalContext(commandId, tab, tabId, focusStatus, screenshot, commandWithContextLocal) {
  var windowId = tab.windowId;
  var match = commandWithContextLocal.contextLocal;
  return {
          id: commandId,
          command: commandWithContextLocal.command,
          contextGlobal: {
            windowRef: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowRef.makeFromRecordingWindowId(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.makeRecordingId(windowId)),
            tabRef: {
              TAG: /* Resolved */0,
              _0: InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabRef.makeFromRecordingTabId(tabId)
            },
            url: {
              TAG: /* Resolved */0,
              _0: OptionUtils$SmartcutsMacros.getExn("undefined tab url during Command.decorateCommandWithLocalContextWithGlobalContext", tab.url)
            },
            focusStatus: focusStatus,
            title: {
              TAG: /* Resolved */0,
              _0: tab.title
            },
            frame: {
              TAG: /* Resolved */0,
              _0: match.frame
            },
            windowGeometry: {
              TAG: /* Resolved */0,
              _0: match.windowGeometry
            },
            targetBoundingRect: match.targetBoundingRect,
            timestamp: match.timestamp,
            htmlSnapshot: match.htmlSnapshot,
            screenshot: screenshot,
            croppedScreenshot: /* NoImage */0,
            preconditions: match.preconditions,
            maybeLogoutLocator: match.maybeLogoutLocator
          }
        };
}

exports.schemaVersion = schemaVersion;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.recordingCommand_encode = recordingCommand_encode;
exports.recordingCommand_decode = recordingCommand_decode;
exports.ForRecording = ForRecording;
exports.authoringCommand_encode = authoringCommand_encode;
exports.authoringCommand_decode = authoringCommand_decode;
exports.ForAuthoring = ForAuthoring;
exports.playbackCommand_encode = playbackCommand_encode;
exports.playbackCommand_decode = playbackCommand_decode;
exports.ForPlayback = ForPlayback;
exports.stringify = stringify;
exports.stringifyRecordingCommand = stringifyRecordingCommand;
exports.stringifyAuthoringCommand = stringifyAuthoringCommand;
exports.stringifyPlaybackCommand = stringifyPlaybackCommand;
exports.updateSelectorInAuthoringCommand = updateSelectorInAuthoringCommand;
exports.CommandWithContextLocal = CommandWithContextLocal;
exports.CommandWithContextGlobalForRecording = CommandWithContextGlobalForRecording;
exports.CommandWithContextGlobalForRecordingResolved = CommandWithContextGlobalForRecordingResolved;
exports.CommandWithContextGlobalForAuthoring = CommandWithContextGlobalForAuthoring;
exports.CommandWithContextGlobalForPlayback = CommandWithContextGlobalForPlayback;
exports.decorateCommandWithGlobalContext = decorateCommandWithGlobalContext;
exports.decorateCommandWithLocalContextWithGlobalContext = decorateCommandWithLocalContextWithGlobalContext;
/* Util-SmartcutsMacros Not a pure module */
